var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPieGradientShadow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6073_35116)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6333 28.7147C49.7409 30.2178 48.5136 31.3329 47.1673 31.3329H37.1673C35.7866 31.3329 34.6673 30.2136 34.6673 28.8329V18.8329C34.6673 17.4866 35.7824 16.2594 37.2856 16.3669C38.7108 16.4689 40.1125 16.7995 41.4364 17.3479C43.0541 18.0179 44.524 19.0001 45.7621 20.2382C47.0002 21.4763 47.9823 22.9461 48.6524 24.5638C49.2008 25.8877 49.5313 27.2895 49.6333 28.7147ZM46.1941 27.9996C46.0691 27.2602 45.8611 26.5355 45.5728 25.8394C45.0702 24.6262 44.3336 23.5238 43.4051 22.5952C42.4765 21.6666 41.3741 20.93 40.1608 20.4275C39.4648 20.1392 38.74 19.9311 38.0007 19.8061V27.9996L46.1941 27.9996Z",
    fill: "url(#paint0_linear_6073_35116)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1673 34.6662C48.5136 34.6662 49.7409 35.7813 49.6333 37.2845C49.5313 38.7097 49.2008 40.1114 48.6524 41.4353C47.9823 43.053 47.0002 44.5229 45.7621 45.761C44.524 46.9991 43.0541 47.9812 41.4364 48.6513C40.1125 49.1997 38.7108 49.5302 37.2856 49.6322C35.7824 49.7398 34.6673 48.5125 34.6673 47.1662V37.1662C34.6673 35.7855 35.7866 34.6662 37.1673 34.6662H47.1673ZM46.1941 37.9996H38.0007L38.0007 46.193C38.74 46.068 39.4648 45.86 40.1608 45.5717C41.3741 45.0691 42.4765 44.3325 43.4051 43.404C44.3336 42.4754 45.0702 41.373 45.5728 40.1597C45.8611 39.4637 46.0691 38.7389 46.1941 37.9996Z",
    fill: "url(#paint1_linear_6073_35116)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.334 32.9995C16.334 36.5357 17.7387 39.9271 20.2392 42.4276C22.5145 44.7029 25.5273 46.0709 28.7157 46.2989C30.2187 46.4064 31.334 45.1793 31.334 43.8329L31.334 22.1662C31.334 20.8198 30.2187 19.5927 28.7158 19.7002C25.5273 19.9282 22.5145 21.2962 20.2392 23.5714C17.7387 26.0719 16.334 29.4633 16.334 32.9995ZM22.5962 40.0706C20.7209 38.1952 19.6673 35.6517 19.6673 32.9995C19.6673 30.3474 20.7209 27.8038 22.5963 25.9284C24.0741 24.4506 25.9668 23.4831 28.0007 23.1393L28.0006 42.8597C25.9668 42.5159 24.0741 41.5484 22.5962 40.0706Z",
    fill: "url(#paint2_linear_6073_35116)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6073_35116",
    x: -3,
    y: -3,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.192157 0 0 0 0 0.847059 0 0 0 0 0.74902 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6073_35116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6073_35116",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6073_35116",
    x1: 20.3783,
    y1: 12.4779,
    x2: 45.6458,
    y2: 64.6898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0965F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6073_35116",
    x1: 20.3783,
    y1: 12.4779,
    x2: 45.6458,
    y2: 64.6898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0965F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6073_35116",
    x1: 20.3783,
    y1: 12.4779,
    x2: 45.6458,
    y2: 64.6898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0965F1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieGradientShadow);
export default __webpack_public_path__ + "static/media/pie-gradient-shadow.a122ff270e4f14c2373304e1a255fc8e.svg";
export { ForwardRef as ReactComponent };